import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { ERoutes } from '../../routes';
import LoyaltyCoins from './LoyaltyCoins';
import LoyaltyHowWorks from './LoyaltyHowWorks';
import LoyaltyRewards from './LoyaltyRewards';
import LoyaltySimulator from './LoyaltySimulator';

export enum ELoyaltyRoutes {
  LOYALTY_HOW_WORKS = '/loyalty-how-works',
  LOYALTY_COINS = '/loyalty-coins',
  LOYALTY_SIMULATOR = '/loyalty-simulator',
  LOYALTY_REWARDS = '/loyalty-rewards'
}

const LoyaltyRoutes: React.FC = () => {
  const path = `${ERoutes.LOYALTY}`;
  return (
    <>
      <Route
        path={`${path}${ELoyaltyRoutes.LOYALTY_COINS}`}
        component={LoyaltyCoins}
      />
      <Route
        path={`${path}${ELoyaltyRoutes.LOYALTY_SIMULATOR}`}
        component={LoyaltySimulator}
      />
      <Route
        path={`${path}${ELoyaltyRoutes.LOYALTY_REWARDS}`}
        component={LoyaltyRewards}
      />
      <Route
        path={`${path}${ELoyaltyRoutes.LOYALTY_HOW_WORKS}`}
        component={LoyaltyHowWorks}
      />
      <Route path={path} exact>
        <Redirect to={`${path}${ELoyaltyRoutes.LOYALTY_COINS}`} />
      </Route>
    </>
  );
};

export default LoyaltyRoutes;
